import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { WatchOptions } from 'vue';
import { CorrespondenceLanguages } from '@/models/VariousEnum';
import { SelectOptionDTO } from '@/models/SelectOptionDTO';
import InputText from '@/components/inputs/InputText/InputText';
import InputSelect from '@/components/inputs/InputSelect/InputSelect';
import InputTel from '@/components/inputs/InputTel/InputTel';
import InputEmail from '@/components/inputs/InputEmail/InputEmail';
import { getCorrespondenceLanguagesBySu } from '@/config/app.config';
import { store } from '@/store/store';
import { IdentificationDTO } from '@/models/IdentificationDTO';

@Component({
  components: {
    InputText,
    InputSelect,
    InputTel,
    InputEmail,
  },
})
export default class ParticipantContact extends Vue {
  @Prop({
    required: true,
    default() {return { email: '', phoneNumber: '', correspondenceLang: ''} as IdentificationDTO; } })
  public value!: IdentificationDTO;

  @Prop({ default: false})
  public readonly!: boolean;

  public identificationData = {} as IdentificationDTO;
  public correspondenceLanguagesOptions: SelectOptionDTO[] = [];
  public selected = '';
  public correspondenceLangConfig: CorrespondenceLanguages[] = [];

  protected get isIdentified(): boolean {
    return store.state.isIdentified;
  }
  protected get isAuthenticated(): boolean {
    return store.state.isAuthenticated;
  }

  protected mounted(): void {
    this.identificationData = this.value;
    this.selected = this.identificationData.correspondenceLang ? this.identificationData.correspondenceLang : '';
    this.correspondenceLangConfig = getCorrespondenceLanguagesBySu(this.$route.params.screening);
    this.initSelect();
  }

  protected initSelect() {
    this.correspondenceLangConfig.map((lang: any) => {
      const option: SelectOptionDTO = {} as SelectOptionDTO;
      option.text = this.$i18n.t(`correspondenceLanguages.${lang}`).toString();
      option.value = lang;
      this.correspondenceLanguagesOptions.push(option);
      if (lang === this.$i18n.locale) {
        this.selected = lang;
        this.identificationData.correspondenceLang = lang;
      }
    });
  }

  protected onSelectChange(selectedValue: string) {
    this.selected = selectedValue;
    this.identificationData.correspondenceLang = selectedValue;
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: IdentificationDTO, oldValue: IdentificationDTO) {
    if (oldValue !== value) {
      this.identificationData = JSON.parse(JSON.stringify(this.value));
      this.selected = this.value.correspondenceLang ? this.value.correspondenceLang : '';
    }
  }
}
